import React, { Component } from "react";
import { Container } from "react-bootstrap";
import PostApiCall from "../Helper/PostApi";
import "./Categorycomponent.css";
export default class CaroselProdectCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      DestinationData: [],
    };
  }
  componentDidMount() {
    localStorage.removeItem("DepartureData");
    PostApiCall.postRequest({ WhereClause: `` }, "GetPackageMaster").then(
      (resultdes) =>
        resultdes.json().then((obj) => {
          this.setState({
            DestinationData: obj.data,
          });
        })
    );
  }
  render() {
    const responsive = {
      desktop: {
        breakpoint: { max: 2000, min: 1024 },
        items: 4,
        slidesToSlide: 3,
      },
      tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
        slidesToSlide: 2,
      },
      mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
        slidesToSlide: 1,
      },
    };

    return (
      <Container className="destinationcard homepage-border p-0">
        <div className="my-3 mb-5 text-center ">
          <h1 className="text-center avenir_bolder comonfontfamilynew">
            Experiential Holidays
          </h1>
          <div className="testunderline mb-3"></div>
          <p className="avenir_regular mt-1 topdestingtagfont commondescripouterhedaing">
            Adding a new mantra to self-discovery, these breakaway holidays
            redefine "giving time a break" where you explore off-beat unique
            places that will surprise you with things from the ordinary and
            "intangible" experiences that will be bragworthy over a coffee table
            conversation.
          </p>
        </div>

        <section className="tour-grid m-0">
          {this.state.DestinationData.map((item, index) => {
            return (
              <div className="position-relative cardhovereffect">
                <p className="tour-date">{item.fld_total_days}</p>
                <a
                  href={`${
                    process.env.PUBLIC_URL
                  }/destinationdetail/${item.fld_display_url.replace(
                    /\s/g,
                    "-"
                  )}/${item.fld_id}`}
                >
                  <article
                    className="tour-card"
                    key={index}
                    style={{ height: "95%" }}
                  >
                    <div className="tour-img-container">
                      <img src={item.fld_banner} className="tour-img" alt="" />
                    </div>
                    <div className="tour-info">
                      <div className="tour-title">
                        <b className="fw-bolder destinationnamepricesamefont">
                          {item.fld_destination_name}
                        </b>
                      </div>
                      {item.fld_price != null && (
                        <h4 className="fw-bold text-secondary">
                          Starting From: ₹ {item.fld_price}
                        </h4>
                      )}
                    </div>
                  </article>
                </a>
              </div>
            );
          })}
        </section>
      </Container>
    );
  }
}
